<script setup lang="ts">
import BackButton from '@/components/ui/BackButton.vue';
import MapComponent from '@/pages/MapPage/MapComponent.vue';
import SearchPanel from '@/pages/SearchPage/index.vue';
import SearchTopBar from '@/pages/MapPage/SearchTopBar.vue';
import { AppRoute } from '@/libs/routing';
import { useRoute, useRouter } from 'vue-router';
import { computed, ref, watch } from 'vue';

const showBackButton = ref<boolean>(false);

const route = useRoute();
const router = useRouter();

// The search is a layer of the home, not a page of its own: the home stays
// mounted (and the map keeps its viewport) while the results panel covers it,
// and the search bar is the same element in both states.
const isHome = computed<boolean>(() => route.name === AppRoute.MAP || route.name === AppRoute.SEARCH);
const isSearch = computed<boolean>(() => route.name === AppRoute.SEARCH);

// The itinerary brings its own close button, next to its fields.
watch(route, () => {
  // Display the back button only if route history exists and if current page is not Map Page
  showBackButton.value =
    router.options.history.state.back !== null && !isHome.value && route.name !== AppRoute.ITINERARY;
});
</script>

<template>
  <div class="page">
    <BackButton v-if="showBackButton" />
    <MapComponent class="content" />

    <!-- Footer pages -->
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>

    <transition name="search-panel">
      <SearchPanel v-if="isSearch" />
    </transition>
    <transition name="fade">
      <SearchTopBar v-if="isHome" :active="isSearch" />
    </transition>
  </div>
</template>
